import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import { formataData } from "../../../helpers/mesesHelper";
import Badge from "../../../components/Common/Badge/Badge";
import Format from "../../../helpers/Format";
import { AppContext } from "../../../contexts/AppContext";
import PropTypes from "prop-types";

function AtivosDataTable({
  colaboradores,
  togSolicitarFeriasModal,
  togSolicitarDemissaoModal,
  togReajustarSalarioModal,
}) {
  const { baseUrl } = React.useContext(AppContext);

  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "nome",
      },
      {
        Header: "CPF",
        accessor: "cpf",
        disableSortBy: true,
      },
      {
        Header: "Salário",
        accessor: (row) => {
          return Format.formataValor(row.salario);
        },
        disableSortBy: true,
      },
      {
        Header: "Data de admissão",
        accessor: (row) => {
          return formataData(row.data_admissao);
        },
        disableSortBy: true,
      },
      {
        Header: "Férias",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = "";

          switch (parseInt(row.original.status_ferias)) {
            case 1:
              status = <Badge color="success">Disponíveis</Badge>;
              break;

            case 2:
              status = <Badge color="warning">Não Disponíveis</Badge>;
              break;

            case 3:
              status = <Badge color="danger">Vencidas</Badge>;
              break;

            default:
              break;
          }
          return status;
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`dados-colaborador-${row.original.uid}`}
                onClick={() => {
                  window.location.href = `${baseUrl}colaboradores/Colaborador/ativo/${row.original.uid}`;
                }}
                color="success"
                icon="mdi mdi-card-account-details"
              >
                Dados do colaborador
              </DropdownButton>
              <DropdownButton
                key={`solicitar-ferias-${row.original.uid}`}
                onClick={() => {
                  togSolicitarFeriasModal(row.original.uid);
                }}
                color="primary"
                icon="bx bxs-plane-alt"
              >
                Solicitar férias
              </DropdownButton>
              <DropdownButton
                key={`reajustar-salario-${row.original.uid}`}
                onClick={() => {
                  togReajustarSalarioModal(
                    row.original.uid,
                    row.original.salario
                  );
                }}
                color="warning"
                icon="mdi mdi-account-cash"
              >
                Reajustar salário
              </DropdownButton>
              <DropdownButton
                key={`solicitar-demissao-${row.original.uid}`}
                onClick={() => {
                  togSolicitarDemissaoModal(
                    row.original.uid,
                    row.original.data_admissao
                  );
                }}
                color="danger"
                icon="mdi mdi-account-cancel"
              >
                Solicitar demissão
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [
      baseUrl,
      togReajustarSalarioModal,
      togSolicitarDemissaoModal,
      togSolicitarFeriasModal,
    ]
  );

  return <CommonDataTable colunas={colunas} linhas={colaboradores} />;
}

AtivosDataTable.propTypes = {
  colaboradores: PropTypes.arrayOf(PropTypes.object).isRequired,
  togSolicitarFeriasModal: PropTypes.func.isRequired,
  togSolicitarDemissaoModal: PropTypes.func.isRequired,
  togReajustarSalarioModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default AtivosDataTable;
